export default "__VITE_ASSET__Dtu65FvL__"